import WhiteNavbar from "components/Navbars/WhiteNavbar";
import React, { useEffect } from "react";
import {
  Badge,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import { FaCheck } from "react-icons/fa";
import Footer from "components/Footers/Footer";
import { HashLink } from "react-router-hash-link";
import { useSize } from "components/SizeControl/SizeControl";
import { Accordion, AccordionTab } from "primereact/accordion";
import imageHeader from "../assets/ossaPictures/hakkimizdaHeader.jpeg";
import PictureHeader from "components/PictureHeader/PictureHeader";
import { useNavigate } from "react-router-dom";
import DynamicCardSection from "components/Hizmetlerimiz/DynamicCardSectionHome";

const SaglikHukuku = () => {
  const { under1200, under992 } = useSize();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    // Sayfa yüklendiğinde .gt-lang-code elementini bul ve değişiklik yap
    const targetLink = document.querySelector('a[data-gt-lang="tr"]'); // Değiştirmeniz gereken class veya id'yi buraya ekleyin

    if (targetLink) {
      // Otomatik tıklama
      targetLink.click();
      const imgElement = document.querySelector(".gt-current-lang img");
      const newImgSrc = "https://cdn.gtranslate.net/flags/32/tr.png"; // Değiştirmeniz gereken yeni resim yolunu buraya ekleyin
      console.log(imgElement);
      imgElement.src = newImgSrc;
      imgElement.width = "32";
      imgElement.height = "32";
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>ÇALIŞMA ALANLARIMIZ | SAĞLIK HUKUKU | ARS HUKUK</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="ARS HUKUK sizin ihtiyaçlarınızı bilir ve en uygun çözümleri sunar"
          data-rh="true"
        />
        <link
          rel="canonical"
          href="https://www.arshukukburosu.com"
        />
        <meta property="og:title" content="HAKKIMIZDA | ARS HUKUK" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="ARS HUKUK sizin ihtiyaçlarınızı bilir ve en uygun çözümleri sunar"
        />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content="https://www.arshukukburosu.com"
        />
      </Helmet>
      <WhiteNavbar navbarSelection={"about-us"} />
      {/* <PictureHeader imageHeader={imageHeader} />
       */}
        <br></br> <br></br> <br></br> <br></br> <br></br>

      <div>
        <Container style={{ fontFamily: "Nucleo Outline" }}>
          <div>
            <br></br>

            <h2
              className="ml-auto mr-auto text-center"
              style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <b>SAĞLIK HUKUKU</b>
            </h2>
          </div>
          <Row>
            <Col className="ml-auto" md="6" style={{ alignContent: "center" }}>
              <img
                alt="Sözleşme ve Borçlar Hukuku"
                className="img rounded"
                src={require("assets/arsPictures/hizmetler/isHukuku.png")}
              ></img>
            </Col>
            <Col
              className="mr-auto mt-5 mt-md-3"
              md="6"
              data-aos="zoom-in"
              data-aos-duration="2000"
              style={{ alignSelf: "center" }}
            >
            <p>
            Sağlık Hukuku, vatandaşların sağlık hizmetlerine erişimi, hasta hakları, sağlık çalışanlarının yükümlülükleri ve sağlık hizmetlerinin düzenlenmesi gibi konuları kapsayan hukuk dalıdır. Hastaların tedaviye rıza göstermesi, bilgilendirilme ve aydınlatılma hakkı, mahremiyetin korunması, tıbbi uygulama hataları (malpraktis) davaları ve özel sağlık kuruluşlarının faaliyetleri gibi konuları ele alır. Sağlık hukuku hastaların haklarını koruyarak, sağlık hizmetlerinin hukuka uygun ve etkili şekilde sunulmasına katkı sağlar. 
            </p>
            
            </Col>
          </Row>
          
          <div className="title">
            <br></br>

            <h2
              className="ml-auto mr-auto text-center"
              style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <b>SIKÇA SORULAN SORULAR</b>
            </h2>
          </div>
          <br></br>
          <div className="card">
          <Accordion activeIndex={0}>
    <AccordionTab header="Bir hasta tedaviyi reddedebilir mi?">
        <p className="m-0">
        Evet, hastalar, kendilerine uygulanacak tedaviyi reddetme hakkına sahiptirler. Ancak acil durumlarda ve
hayati tehlike söz konusu olduğunda bu hak sınırlı olabilir
        </p>
    </AccordionTab>
    <AccordionTab header="Tıbbi hatalar durumunda ne yapılabilir?">
        <p className="m-0">
            Tıbbi hatalar, sağlık çalışanlarının kusurlu davranışlarından kaynaklanan durumlardır. Bu tür durumlarda
hastalar, hukuki yollara başvurarak tazminat talep edebilirler.
        </p>
    </AccordionTab>
    <AccordionTab header="Hasta bilgileri nasıl korunur?">
        <p className="m-0">
        Hasta bilgileri, gizlilik ilkesi gereği korunmalıdır. Bu bilgiler, hastanın izni olmadan paylaşılmamalıdır
ve sadece sağlık hizmetlerinin sunulması amacıyla kullanılmalıdır.
        </p>
    </AccordionTab>
    {/* <AccordionTab header="Sağlık Hukuku nedir?">
        <p className="m-0">
            Sağlık hukuku, sağlık hizmetleri sunumu, hasta hakları, tıbbi uygulamaların düzenlenmesi ve sağlık sektöründe yer alan tarafların haklarını koruyan hukuk dalıdır. Sağlık hukuku, sağlık hizmetlerinin kalitesini ve erişimini sağlamayı amaçlar.
        </p>
    </AccordionTab>
    <AccordionTab header="Hasta hakları nelerdir?">
        <p className="m-0">
            Hasta hakları, hastaların tıbbi müdahalelere, bilgiye erişim hakkı, onur ve mahremiyetin korunması gibi temel hakları içerir. Hasta hakları, sağlık hizmetlerinden yararlanan herkes için önemli bir koruma sağlar.
        </p>
    </AccordionTab>
    <AccordionTab header="Tıbbi malpraktis nedir?">
        <p className="m-0">
            Tıbbi malpraktis, sağlık hizmeti sunan profesyonellerin ihmali veya hatalı müdahaleleri sonucu ortaya çıkan zararları ifade eder. Tıbbi malpraktis durumlarında hasta veya yakınları tazminat talebinde bulunabilir.
        </p>
    </AccordionTab>
    <AccordionTab header="Sağlık kuruluşlarının sorumlulukları nelerdir?">
        <p className="m-0">
            Sağlık kuruluşları, hasta güvenliği, sağlık hizmetlerinin kalitesi ve çalışanların eğitimi gibi konularda sorumluluk taşır. Sağlık hukuku bu kuruluşların yükümlülüklerini düzenler ve denetler.
        </p>
    </AccordionTab>
    <AccordionTab header="Sağlık bilgilerinin gizliliği ve korunması nasıl sağlanır?">
        <p className="m-0">
            Sağlık bilgileri, hasta mahremiyetinin korunması gereken önemli verilerdir. Sağlık hukuku, sağlık bilgilerinin gizliliğini sağlamak ve bu bilgilerin izinsiz kullanılmasını önlemek için çeşitli düzenlemeler içerir.
        </p>
    </AccordionTab>
    <AccordionTab header="ARS Hukuk Bürosu'nda sağlık hukuku alanında nasıl hizmet verilmektedir?">
        <p className="m-0">
            ARS Hukuk Bürosu, müvekkillerine tıbbi malpraktis davaları, hasta hakları ihlalleri, sağlık kuruluşlarının hukuki danışmanlığı ve sağlık hukukuyla ilgili geniş kapsamlı hizmetler sunmaktadır.
        </p>
    </AccordionTab> */}
</Accordion>



          </div>
          <div className="team-2 pb-0 pt-0">
            <DynamicCardSection />
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default SaglikHukuku;
